export const PLAY_MODULE = 1;
export const RESTART_MODULE = 2;
export const ROLL_MODULE = 3;
export const PLAY_SPEED_MODULE = 4;
